import { OrderTypeResponse } from "../../../codegen-api";
import { knownPrice } from "../../../utils/unknownNumbers";

/**
 * The price a USDC-denominated order is converted to a base size at: the
 * trader's own limit price, else the market's mark.
 *
 * The index is deliberately not an input. It used to stand in for a missing
 * mark, but the two are different prices and the backend no longer substitutes
 * one for the other. An unknown mark gives `undefined`, so the caller fails
 * visibly instead of sizing at 0 or at the wrong price.
 */
export const sizingPriceForOrder = ({
  orderType,
  limitPrice,
  markPrice,
}: {
  orderType?: OrderTypeResponse;
  limitPrice?: string | number | null;
  markPrice?: string | number | null;
}): number | undefined =>
  orderType === OrderTypeResponse.Limit && limitPrice
    ? knownPrice(limitPrice)
    : knownPrice(markPrice);
